import { View } from "extensions/marionette";

import all_credentialsTemplate from "./all_credentials.jst";
import { ViewCredentialsTable } from "./viewCredentialsTable";
import { SearchCredentials } from "./searchCredentials";

import { CredentialsCollection } from "./credentialsCollection";

export const AllCredentialsView = View.extend({
    className: "allCredentials",
    
    template: all_credentialsTemplate,
    regions: {
        searchCredentials: ".search-credentials",
        viewCredentials: ".view-credentials"
    },
    
    childViewEvents: {
        "tokens:update": "updateCollectionWithNewSearchTokens",
        "active:update": "setActiveFlag",
        "expired:update": "setExpiredFlag"
    },
    
    initialize() {
        this.state = {
            tokens: null
        };
        
        this.collection = new CredentialsCollection();
    },
    
    setActiveFlag({ checked }) {
        if (this.state.tokens) {
            this.updateCollectionWithNewSearchTokens(this.state.tokens);
        } else {
            this.collection.filterBy({
                active: checked ? "all" : "active"
            });
        }
    },
    
    setExpiredFlag({ checked }) {
        if (this.state.tokens) {
            this.updateCollectionWithNewSearchTokens(this.state.tokens);
        } else {
            this.collection.filterBy({
                expired: checked ? "yes" : "no"
            });
        }
    },
    
    updateCollectionWithNewSearchTokens(tokens) {
        this.state.tokens = tokens;
        const params = tokens.reduce((memo, t) => {
            if (t.group) {
                memo[t.group] = t.value;
            } else {
                memo.other = t.value;
            }
            return memo;
        }, {});
    
        params.active = this.el.querySelector(".showInactive").checked ? "all" : "active";
        
        this.collection.resetParams();
        this.collection.filterBy(params);
    },
    
    onRender() {
        this.showChildView("searchCredentials", new SearchCredentials({
            collection: this.collection
        }));
        this.showChildView("viewCredentials", new ViewCredentialsTable({
            collection: this.collection
        }));
    
        this.collection._setQueryParamsAndFetch({
            active: "active",
            expired: "no"
        });
    }
});
